import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { NoopInterceptor } from './http';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: NoopInterceptor,
    multi: true,
  }],
  declarations: [],
  exports: [
    HttpClientModule
  ]
})
export class HttpModule { }



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/lib/interceptor/interceptor.module.ts